import { Dispatch } from 'react';
import {
  TableColumn,
} from "../components/CommnTable/CustomDataTable";

export interface Task {
  id: number;
  title: string;
  description: string;
  completed: boolean;
}

export interface CreateTaskPayload {
  title: string;
  description: string;
}

export interface UpdateTaskPayload {
  id: number;
  title?: string;
  description?: string;
  completed?: boolean;
}

export interface Applicant {
  appId: number;
  name: string;
  phone: string;
  status: string;
  college: string;
  district: string;
  state: string;
  achievement: string;
  stream: string;
  viewapp?: string;
  evform?: string;
  evaluationStatus?: string;
}
export interface ApplicantInterface {
  application_id: number;
  phone_number: string;
  status: string;
  name: string | null;
  college_name: string | null;
  district: string | null;
  state: string | null;
  achivements: boolean;
  stream: string | null;
  viewapp?: string | null;
  evform?: string | null;
  evaluation: boolean;
  email: string | null;
}
export interface FundsAllowInterface {
  startDate: number;
  endDate: string;
  firstpayment: number | null,
  firstpaymentdate:string | null,
  funds: any[];
}
export interface FundsAllowDetailsInterface {
  id: number;
  scholarship_start_dt: string;
  amount: number;
  course: string;
  completd_at: string;
  Completed_remarks: string;
  onhold_remarks: null;
  created_at: string;
  updated_at: string;
  scholarship_end_dt: string;
  batch: string;
  status: null;
  cancelled_at: null;
  Cancalled_remarks: null;
  onhold_at: null;
  first_payment_amt: null,
  first_payment_dt: null,
  fund_allocation: [
    {
      created_at: string;
      updated_at: string;
      purpose: string;
      frequency: string;
      total_amt: number;
      id: number;
      scholarship_id: number;
      allocation_amount: number;
      no_of_installment: number;
    }
  ];
}
export interface FundsInterface {
  scholarship_id: number;
  id: number;
  status: string;
  name: string | null;
  course: string | null;
  amount_paid_till_date: string | null;
  action?: string | null;
  purpose?: string[];
  user_id?: number | null;
  new_purpose?: any[];
}

export interface FundsPaymentInterface {
  scholarship_id: number;
  name: string | null;
  course: string | null;
  Funds_Disbursed: string | null;
  date_of_payment: string | null;
  description: string | null;
  purpose: string | null;
  dd_details: string | null;
  cheque_details: string | null;
  transaction_ID: string | null;
  next_installment: string | null;
  next_installment_dt: string | null;
  installment_given: string | null;
  customBody?: (row: FundsPaymentInterface) => React.ReactNode;
  action?: string;
  id: number;
}

export interface ScholarshipSummaryInterface {
  id: number;
  scholarship_id: number | string;
  name: string;
  course: string;
  status: string;
  college_school: string;
  commitment_period: string;
  amount_committed_per_year: string;
  batch: string;
  amount_paid_till_date: string;
  next_due_installments: string;
  next_installment_amount: string;
  balance_funds_required_till_date: string;
  total_fund_approval: string;
  continue_funding_till: string;
  actions: string;
  user_id: number;
}

export interface FilesInterface {
  doc_name: string;
  doc_url: string;
  doc_type?: string;
  action?: string;
  updatedDate?: string;
}
export interface ApplicantForm {
  application_submission_dt: string;
  final_status: string;
  scholarship_id: string;
  source_of_infomation: string;
  verified_by: string;
  status: string;
  scholarship_grant_start_date: string;
  phone_number: string;
  scholarship_grant_till_date: string;
  created_at: string;
  verification_commnets: string;
  id: number;
  interviewer_id: string;
  updated_at: string;
  interviwer_commnets: string;
  personal_info: {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    dob: string;
    home_address: string;
    city: string;
    zipcode: string;
    state: string;
    district: string;
    photo_url: string;
    facebook_url: string;
    instagram_url: string;
    linkedin_url: string;
    gender: string;
    scholarship_name: string;
    scholarship_status: string;
  };
  completedEducation: [
    {
      id: number;
      title: string;
      institution: string;
      address: string;
      university_name: string;
      stream: string;
      course: string;
      total_marks_cgpa: number;
      year_of_passing: string;
      principal_name: string;
      principal_ph: string;
      marksheet_url: string;
      file_name: string;
    }
  ];
  presentEducation: [
    {
      id: number;
      institution: string;
      address: string;
      university_name: string;
      stream: string;
      course: string;
      Year_of_Admission: string;
      Current_sem: string;
      Course_dur: string;
      principal_name: string;
      principal_ph: string;
      Course_fee: number;
      Frequency_of_payment: string;
      Fees_Already_paid: number;
    }
  ];
  achievements: [
    {
      id: number;
      achievement: string;
      supporting_doc_url: string;
      file_name: string;
    }
  ];
  family_details: {
    id: number;
    father_name: string;
    mother_name: string;
    guardian_name: string;
    father_occupation: string;
    mother_occupation: string;
    monthly_familiy_income: number;
    guardian_ph_number: string;
    siblings: [
      {
        id: number;
        sibling_name: string;
        relationship: string;
        occupation: string;
        sister_husband_name: string;
        sister_husband_occupation: string;
      }
    ];
  };
  bank_details: [
    {
      id: number;
      title: string;
      bank_name: string;
      account_holder_name: string;
      account_no: string;
      IFSC_no: string;
      branch: string;
    }
  ];
  additional_documents: [
    {
      id: number;
      doc_name: string;
      doc_url: string;
    }
  ];
  scholarship_purpose: {
    source_of_infomation: string;
    scholarship_purpose: string;
    other_scholarships: [
      {
        id: number;
        scholarship_name: string;
        scholarship_amount: number;
      }
    ];
  };
  scholarship: {
    id: number;
    scholarship_start_dt: string;
    amount: number;
    course: string;
    completd_at: string;
    Completed_remarks: string;
    onhold_remarks: null;
    created_at: string;
    updated_at: string;
    scholarship_end_dt: string;
    batch: string;
    status: null;
    cancelled_at: null;
    Cancalled_remarks: null;
    onhold_at: null;
    coordinator: null;
    fund_allocation: [
      {
        created_at: string;
        updated_at: string;
        purpose: string;
        frequency: string;
        total_amt: number;
        id: number;
        scholarship_id: number;
        allocation_amount: number;
        no_of_installment: number;
      }
    ];
  };
}
export interface DorpdownInterFace {  
  courses:string[],
  streams:string[],
  coordinators:[
    {
      id: number,
      name: string
    }
  ],
}
export interface AttendenceInterface {
  attendenceDate: string;
  status: string;
  remaindStatus?: string;
  percentage?: "Present" | "Absent";
}
export const requiredPersonalInfoFields = [
  "first_name",
  "last_name",
  "email",
  "phone",
  "dob",
  "home_address",
  "city",
  "zipcode",
  "state",
  "district",
  "photo_url",
  // "facebook_url",
  // "instagram_url",
  // "linkedin_url",
  "gender",
];
export const requiredPersonalInfoFormFields = [
  "firstName",
  "lastName",
  "dateOfBirth",
  "mobileNumber",
  "email",
  "gender",
  "permanentHomeAddress",
  "city",
  "state",
  "district",
  "zipcode",
  "profilePhoto",
  "profilePhotoName",
];
export interface FundAllocationValues {
  startDate: string;
  endDate: string;
  firstpayment:number|null,
  firstpaymentdate:string|null,
  funds: FundRow[];
}
export interface FundsAllowDetailsInterface {
  id: number;
  scholarship_start_dt: string;
  amount: number;
  course: string;
  completd_at: string;
  Completed_remarks: string;
  onhold_remarks: null;
  created_at: string;
  updated_at: string;
  scholarship_end_dt: string;
  batch: string;
  status: null;
  cancelled_at: null;
  Cancalled_remarks: null;
  onhold_at: null;
  fund_allocation: [
    {
      created_at: string;
      updated_at: string;
      purpose: string;
      frequency: string;
      total_amt: number;
      id: number;
      scholarship_id: number;
      allocation_amount: number;
      no_of_installment: number;
    }
  ];
}
export interface FundRow {
  purpose: string;
  allocationAmount: number | "";
  frequency: string;
  installments: number | "";
  totalAmount: number | "";
}

export interface ScholarshipSummaryType {
  id: number;
  user_id: number;
  scholarship_id: number | string;
  name: string;
  course: string;
  status: string;
  college_school: string;
  commitment_period: string;
  amount_committed_per_year: string;
  batch: string;
  amount_paid_till_date: string;
  next_due_installments: string;
  next_installment_amount: string;
  balance_funds_required_till_date: string;
  total_fund_approval: string;
  continue_funding_till: string;
  actions: string;
  status_update: string;
  stream: string;
}

 export interface ScholarshipReportType {
    scholarship_id: string;
    Name: string;
    course: string;
    Stream: string;
    scholarship_id_1: number,
    next_installment_dt: string;
    next_installment_purpose: string;
    next_installment_amt: number,
    account_holder_name: string;
    account_no: string;
    IFSC_no: string;
    branch: string;
    bank_name: string;
}

export interface ScholarshipSummaryFilters {
    payment_date: string,
    cheque_clearing_date: string,
    course: string,
    school_or_institute: string,
    paid_to: string,
    transaction_number: string,
    cheque_number: string,
    dd_number: string,
    amount: number,
    purpose: string,
}

export interface ScholarshipSummaryFund {
  scholarship_id: string;
  name: string;
  course: string;
  status: string;
  college_school: string;
  commitment_period: string;
  amount_committed_per_year: number;
  batch: string;
  amount_paid_till_date: number;
  next_due_installments: string;
  next_installment_amount: string;
  balance_funds_required_till_date: number;
  total_fund_approval: number;
  continue_funding_till: string;
  start_date: string;
  end_date: string;
  first_payment_dt: string,
  first_payment_amt: number,
  fund_allocated: [
    {
      scholarship_id: number;
      id: number;
      allocation_amount: number;
      no_of_installment: number;
      updated_at: string;
      created_at: string;
      purpose: string;
      frequency: string;
      total_amt: number;
      is_disabled: boolean;
    }
  ];
  first_payment_purpose: string;
}

export type FieldType =
  | "text"
  | "email"
  | "password"
  | "number"
  | "select"
  | "checkbox"
  | "date"
  | "button"
  | "textArea"
  | "textWithDropDown";

export interface FormField<T = any> {
  subText?: any;
  name: keyof T & string;
  label?: string;
  type: FieldType;
  required?: boolean;
  options?: any[];
  disabled?: boolean;
  defaultValue?: any;
  slotProps?: any;
  text_label?: string;
  inputProps?:any;
  onClick?: (data: any) => void;
  validate?: (val: any) => string | undefined | boolean;
  grid?: { xs?: number; sm?: number; md?: number; lg?: number };
  dropdownKeyMap?: string;
}

export interface ButtonField {
  name: string;
  onClick: (data: any) => void;
  disabled?: boolean;
  ButtonColor?: "inherit" | "error" | "primary" | "secondary" | "info" | "success" | "warning";
}

export interface FormGeneratorProps<T> {
  fields: FormField<T>[];
  onSubmit: (data: T) => void;
  submitLabel?: string;
  direction?: "row" | "column";
  showSubmit?: boolean;
  buttonColor?:
    | "inherit"
    | "error"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning";
  ButtonList?: ButtonField[];
}

export interface FundViewExpense {
  scholarship_id: number;
  fund_date: string | null;
  purpose: string | null;
  status: string | null;
  amount: string | null;
  action?: string | null;
  id:number;
  HeaderComponent?: React.ReactNode | (() => React.ReactNode);
  customBody?:  (row: FundsPaymentInterface) => React.ReactNode;
}

export interface StudentEvaluationList {
  scholarship_id: number;
  name: string | null;
  course: string | null;
  status: string | null;
  evaluation_date: string | null;
  action: string | null;
  id: number;
  user_id: number | null;
}
export interface PastStudentEvaluationList {
  evaluator_name: string | null;
  interview_date: string | null;
  evaluation_outcome: string | null;
  action: string | null;
  id: number;
  scholarship_id: number;
}

export interface ChangeField {
  text: string;
  prefix: string;
}

export interface TextFieldWithPrefixProps {
  ref?:any;
  prefixOptions?: any[];
  label?: string;
  onChange?: (data: ChangeField) => void;
  defaultPrefix?: string;
  ShowIcon?: boolean;
  selectClassName?: string;
  inputClassName?: string;
  selectSx?:object;
  inputSx?:object;
  defaultValue?:any;
  variant?:'filled'| 'outlined'| 'standard'
  slectedPrefix?:string;
};

export interface FileUploadProps {
  onFileSelect: (filedata: File) => void;
  accept?: string;
}

export interface UploadedFileProps {
  blobFileUrl?: string;
  secureBlobUrl: string;
  filename: string;
  fileType?: string;
  file?: File
}

export interface UploadedFileListProps {
  filename: string;
  fileType?: string;
  action?: string;
  secureBlobUrl:string;
  file: File;
  customBody?:  (row:UploadedFileProps) => React.ReactNode;
}

export interface ContextType {
  fundDetail: FundsInterface | null;
  setFundExpense: (fund: FundsInterface | null) => void;
}

export interface AddFundModeType {
  setOpen: (pre: boolean) => void; 
  open:boolean;
  file: any;
  data: any;
  type: any;
  columns:TableColumn<UploadedFileListProps>[];
  handleUploadReceipt:(filedata: File) => Promise<void>;
  id:string | undefined;
  ViewReceiptColumn: any;
}

export interface RevenueChartType {
  name: string;
  expense: number;
}

export interface RevenueChartProps {
  data: RevenueChartType[];
};

export interface AttendanceChartType {
  name: string;
  value: number;
  color: string;
};

export type AttendanceChartProps = {
  data: RevenueChartType[];
};

export interface NewCandidatesType {
  id: number;
  name: string;
  email: string;
  avatar: string;
}

export type NewCandidatesProps = {
  candidates: NewCandidatesType[];
};

export interface StudentRatio {
  course: string;
  male: number;
  female: number;
};

export type StudentRatioProps = {
  studentRatio: StudentRatio[];
};

export interface AttendanceProps {
  name:string,
  email: string,
  scholarship_id:string,
  records: {
    user_id: number;
    id: number;
    created_at: string;
    updated_at: string;
    attendance_date: string;
  }[];
}
export interface AttendanceRecord  {
    user_id: number,
    id: number,
    created_at: string,
    updated_at: string,
    attendance_date: string
}



export type AttendanceData = {
  name: string;
  email: string;
  records: AttendanceRecord[];
  scholarship_id:string;
};

export type TransformedRecord = {
  id: number;
  name: string;
  email: string;
  percentage: number;
  updatedDate: string;
  createdDate: string
  scholarship_id:string;
};